import { render, staticRenderFns } from "./pardakht-shakhi-wage-plan.vue?vue&type=template&id=5f36d59d&scoped=true"
import script from "./pardakht-shakhi-wage-plan.vue?vue&type=script&lang=js"
export * from "./pardakht-shakhi-wage-plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f36d59d",
  null
  
)

export default component.exports